import { schema } from 'normalizr';
import channel from './channel';

const recordSchema = new schema.Entity('records', {
  channel,
});

export default recordSchema;
